import { BrowserModule } from '@angular/platform-browser';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CoreModule } from './core/core.module';
import { SharedModule } from './layouts/shared.module';

// i18n support
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient } from '@angular/common/http';
import { APIService } from './data/service/master/api.service';
import { AuthenticationService } from './data/service/master/authentication.service';
import { HttpService } from './data/service/master/http.service';
import { AuthGuard } from './core/guard/auth.guard';
import { HttpClientModule } from "@angular/common/http";
// import { QRCodeModule } from 'angular2-qrcode';
// import { NgxQRCodeModule } from '@techiediaries/ngx-qrcode';
import { FormsModule } from '@angular/forms';
import { VnptpayComponent } from './modules/vnptpay/vnptpay.component';
import { AngularFireModule } from '@angular/fire';
import { environment } from 'src/environments/environment';
import { AngularFireMessagingModule } from '@angular/fire/messaging';
import { APIServiceGDNN } from './data/service/master/api-gdnn.service';
import { AsyncPipe } from '@angular/common';
import { APIServiceBaoCaoGDNN } from './data/service/master/api-baocao-gdnn.service';
import { AggAPIService } from './data/service/angiang/agg.api.service';
import { HgiAPIService } from './data/service/haugiang/hgi.api.service';
// import { StoreModule } from '@ngrx/store';
// import { EffectsModule } from '@ngrx/effects';

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
  declarations: [
    AppComponent,
    VnptpayComponent,
  ],
  imports: [
    BrowserModule,
    CoreModule,
    SharedModule,
    HttpClientModule,
    FormsModule,

    AppRoutingModule,
    BrowserAnimationsModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient]
      }
    }),
    AngularFireModule.initializeApp(environment.firebase),
    AngularFireMessagingModule,
    // StoreModule.forRoot({}),
    // EffectsModule.forRoot([]),
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  exports: [TranslateModule],
  bootstrap: [AppComponent],
  providers: [APIService, AggAPIService, HgiAPIService, AuthenticationService, HttpService, AuthGuard, APIServiceGDNN, AsyncPipe, APIServiceBaoCaoGDNN]
})
export class AppModule { }
